import { render, staticRenderFns } from "./transportSwitch.vue?vue&type=template&id=16069a8e&scoped=true&"
import script from "./transportSwitch.vue?vue&type=script&lang=ts&setup=true&"
export * from "./transportSwitch.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./transportSwitch.vue?vue&type=style&index=0&id=16069a8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16069a8e",
  null
  
)

export default component.exports